import * as React from 'react';
import { Image, StyleSheet, TouchableOpacity, View, } from 'react-native';
import { Typography } from '../../typography/Typography';
import { ColorTokens, StepperTypeTokens, TypographyTypeDLS, } from '@voltmoney/schema';
import { Stepper } from "../../stepper/Stepper";
/* fonts */
const FontFamily = {
    mobileHeadingH4Semibold: 'Poppins-SemiBold',
    mobileBodyNormalB1Semibold: 'Inter-SemiBold',
    interRegular: 'Inter-Regular',
    mobileBodyNormalB1Medium: 'Inter-Medium',
    mobileBodyNormalB0Bold: 'Inter-Bold',
};
/* font sizes */
const FontSize = {
    mobileHeadingH4Semibold_size: 16,
    mobileBodyNormalB1Semibold_size: 14,
    mobileBodyNormalB3Semibold_size: 10,
};
/* Colors */
const Color = {
    primary05: '#f3f5fc',
    primary100: '#1434cb',
    greyNight: '#1d2939',
    greyWhite: '#fff',
    colorWhitesmoke: '#f1f3f5',
    greyCharcoal: '#667085',
};
/* Paddings */
const Padding = {
    p_base: 16,
};
/* border radiuses */
const Border = {
    br_xs: 12,
    br_7xs_5: 6,
};
const LoanForeclosureRequestProcessing = ({ triggerAction, goBackAction, needHelpAction, height, stepperData }) => {
    return (React.createElement(View, { style: styles.frameParent },
        React.createElement(View, { style: { flexDirection: 'row' } },
            React.createElement(Image, { source: {
                    uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/hour_glass_blue.png',
                }, style: { width: 48, height: 48 } }),
            React.createElement(View, { style: { marginLeft: 12, alignItems: 'center', alignSelf: 'center', alignContent: 'center' } },
                React.createElement(Typography
                // @ts-ignore
                , { 
                    // @ts-ignore
                    label: 'Loan closure request', typeDLS: TypographyTypeDLS.H3S, color: ColorTokens.Grey_Night }))),
        React.createElement(View, { style: {
                borderStyle: 'dashed',
                borderWidth: 1,
                borderRadius: 1,
                borderColor: '#E4E7EC',
                marginTop: 16,
                marginBottom: 20
            } }),
        React.createElement(Stepper, { type: StepperTypeTokens.VERTICAL, data: stepperData, isProcessing: true }),
        React.createElement(View, { style: {
                borderStyle: 'dashed',
                borderWidth: 1,
                borderRadius: 1,
                borderColor: '#E4E7EC',
                marginTop: 4,
            } }),
        React.createElement(TouchableOpacity, { style: { marginTop: 20, alignSelf: 'center', alignItems: 'center', alignContent: 'center' }, onPress: () => {
                if (needHelpAction) {
                    triggerAction(needHelpAction);
                }
            } },
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B0B, label: 'Need help? Contact us', color: ColorTokens.Primary_100 }))));
};
const styles = StyleSheet.create({
    frameGroupFlexBox: {
        alignItems: 'center',
        alignSelf: 'stretch',
    },
    frameSpaceBlock: {
        marginTop: 16,
        overflow: 'hidden',
        alignSelf: 'stretch',
    },
    groupPosition: {
        left: 0,
        position: 'absolute',
        flexDirection: 'row',
    },
    weWillApproveTypo: {
        color: Color.greyCharcoal,
        fontFamily: FontFamily.mobileBodyNormalB1Medium,
        fontWeight: '500',
        lineHeight: 20,
        fontSize: FontSize.mobileBodyNormalB1Semibold_size,
        marginLeft: 12,
        textAlign: 'left',
        flex: 1,
    },
    frameChild: {
        borderRadius: 6,
        width: 48,
        height: 48,
        overflow: 'hidden',
    },
    yourLoanForeclosure: {
        fontSize: FontSize.mobileHeadingH4Semibold_size,
        lineHeight: 24,
        fontWeight: '700',
        fontFamily: FontFamily.mobileBodyNormalB0Bold,
        marginLeft: 12,
        textAlign: 'left',
        color: Color.greyNight,
        flex: 1,
    },
    frameGroup: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    frameWrapper: {
        justifyContent: 'center',
        alignSelf: 'stretch',
    },
    frameItem: {
        maxWidth: '100%',
        height: 1,
        width: '100%',
    },
    nextSteps: {
        fontWeight: '600',
        fontFamily: FontFamily.mobileBodyNormalB1Semibold,
        lineHeight: 20,
        fontSize: FontSize.mobileBodyNormalB1Semibold_size,
        textAlign: 'left',
        color: Color.greyNight,
        alignSelf: 'stretch',
    },
    nextStepsWrapper: {
        justifyContent: 'center',
    },
    groupChild: {
        top: 11,
        left: 11,
        width: 1,
        height: 49,
        position: 'absolute',
    },
    frameInner: {
        width: 24,
        height: 24,
    },
    groupParent: {
        top: 0,
        width: 295,
    },
    statusOfCollateral: {
        alignSelf: 'stretch',
    },
    groupContainer: {
        top: 56,
        width: 296,
    },
    vectorParent: {
        height: 116,
        marginTop: 8,
        alignSelf: 'stretch',
    },
    frameContainer: {
        borderRadius: Border.br_xs,
        justifyContent: 'center',
    },
    frameParent: {
        borderRadius: 12,
        padding: 16,
        backgroundColor: 'white'
    },
    circle: {
        width: 24,
        height: 24,
        borderRadius: 24 / 2,
        backgroundColor: '#98A2B3',
        justifyContent: 'center',
        alignItems: 'center',
    },
});
export default LoanForeclosureRequestProcessing;
